import React, { useEffect, useState } from "react";
import { api } from "@/lib/config";
import { Plus, Edit2, Trash2, X, Save } from "lucide-react";

const EMPTY = { quote: "", author: "", role: "", company: "", order: 0 };

export default function AdminTestimonials() {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(EMPTY);

  const load = () => api.get("/testimonials").then(({ data }) => setItems(data));
  useEffect(() => { load(); }, []);

  const onSave = async () => {
    if (editing === "new") await api.post("/admin/testimonials", form);
    else await api.put(`/admin/testimonials/${editing}`, form);
    setEditing(null); load();
  };

  const onDelete = async (id) => {
    if (!window.confirm("Supprimer ce témoignage ?")) return;
    await api.delete(`/admin/testimonials/${id}`); load();
  };

  return (
    <div>
      <div className="flex items-end justify-between">
        <div>
          <p className="section-num">Témoignages</p>
          <h1 className="display text-4xl mt-3">Témoignages clients</h1>
        </div>
        <button onClick={() => { setEditing("new"); setForm(EMPTY); }} className="btn-pill btn-primary" data-testid="admin-new-testimonial">
          <Plus size={16}/> Nouveau
        </button>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
        {items.map(t => (
          <div key={t.id} className="bg-paper p-6 border border-ink/10" data-testid={`admin-testimonial-${t.id}`}>
            <p className="text-sm text-ink/85 leading-relaxed line-clamp-4">"{t.quote}"</p>
            <div className="flex items-center justify-between mt-4 pt-4 border-t border-ink/10">
              <div>
                <p className="display text-base">{t.author}</p>
                <p className="text-xs text-ink/60">{t.role} {t.company && `· ${t.company}`}</p>
              </div>
              <div className="flex gap-1">
                <button onClick={() => { setEditing(t.id); setForm({ quote: t.quote, author: t.author, role: t.role, company: t.company, order: t.order }); }} className="p-2 hover:bg-ink/5"><Edit2 size={14}/></button>
                <button onClick={() => onDelete(t.id)} className="p-2 hover:bg-paper-2 text-accent-pink"><Trash2 size={14}/></button>
              </div>
            </div>
          </div>
        ))}
      </div>

      {editing && (
        <div className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-6" onClick={() => setEditing(null)}>
          <div className="bg-paper max-w-2xl w-full" onClick={(e) => e.stopPropagation()}>
            <div className="p-8 border-b border-ink/10 flex items-center justify-between">
              <h2 className="display text-2xl">{editing === "new" ? "Nouveau témoignage" : "Modifier"}</h2>
              <button onClick={() => setEditing(null)}><X size={22}/></button>
            </div>
            <div className="p-8 space-y-5">
              <div>
                <label className="text-xs uppercase tracking-wider text-ink/60">Citation</label>
                <textarea className="field" rows={6} value={form.quote} onChange={e => setForm(f => ({ ...f, quote: e.target.value }))}/>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                <div><label className="text-xs uppercase tracking-wider text-ink/60">Auteur</label><input className="field" value={form.author} onChange={e => setForm(f => ({ ...f, author: e.target.value }))}/></div>
                <div><label className="text-xs uppercase tracking-wider text-ink/60">Rôle</label><input className="field" value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))}/></div>
                <div><label className="text-xs uppercase tracking-wider text-ink/60">Entreprise</label><input className="field" value={form.company} onChange={e => setForm(f => ({ ...f, company: e.target.value }))}/></div>
                <div><label className="text-xs uppercase tracking-wider text-ink/60">Ordre</label><input type="number" className="field" value={form.order} onChange={e => setForm(f => ({ ...f, order: parseInt(e.target.value) || 0 }))}/></div>
              </div>
              <div className="flex gap-3 pt-4">
                <button onClick={onSave} className="btn-pill btn-primary" data-testid="admin-save-testimonial"><Save size={16}/> Enregistrer</button>
                <button onClick={() => setEditing(null)} className="btn-pill btn-ghost">Annuler</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
